import { IPartInventoryItem } from 'parts/types';

export const getLocationValue = (
  item?: Pick<IPartInventoryItem, 'locationName' | 'externalLocationId'>,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _isAlternateVersionEnabled?: boolean
) => {
  if (!item) {
    return '';
  }

  // Used as the display / sort / filter value for the Location column. Always combine
  // locationName + externalLocationId so anonymous external rows don't collapse and two
  // locations sharing a name but differing externalLocationId stay distinct.
  return [item.locationName, item.externalLocationId].filter(Boolean).join(' ');
};

// Stricter identity key for dedupe / tree-data grouping. Adds `id` on top of the display
// fields so rows are never accidentally collapsed when locationName + externalLocationId
// happen to match across different underlying records.
export const getLocationKey = (
  item?: Pick<IPartInventoryItem, 'id' | 'locationName' | 'externalLocationId'>
) => {
  if (!item) {
    return '';
  }

  return [item.id, item.locationName, item.externalLocationId].filter(Boolean).join('-');
};
